export type ChainSymbol =
  | 'ETH'
  | 'BSC'
  | 'BSC_TESTNET'
  | 'METER'
  | 'POLYGON'
  | 'HECO'
  | 'AVAX'
  | 'FTM'
  | 'OPTIMISM'
  | 'ARBITRUM'
  | 'ARBITRUM_SEPOLIA_TESTNET'
  | 'GNOSIS'
  | 'KLAYTN'
  | 'AURORA'
  | 'ELROND'
  | 'TON'
  | 'BTTC'
  | 'TRON'
  | 'OKX'
  | 'MOONBEAM'
  | 'CRONOS'
  | 'ZKSYNC'
  | 'HARMONY'
  | 'KAVA'
  | 'CANTO'
  | 'PULSECHAIN'
  | 'BASE'
  | 'ARTHERA'
  | 'ARTHERA_TESTNET'
  | 'MANTA'
  | 'METIS'
  | 'CONFLUX'
  | 'LINEA'
  | 'SOLANA';

type IChain = Record<ChainSymbol, number>

const chainMapping: IChain = {
  'ETH': 1,
  'BSC': 56,
  'BSC_TESTNET': 97,
  'METER': 82,
  'POLYGON': 137,
  'HECO': 128,
  'AVAX': 43114,
  'FTM': 250,
  'OPTIMISM': 10,
  'ARBITRUM': 42161,
  'ARBITRUM_SEPOLIA_TESTNET': 421614,
  'GNOSIS': 100,
  'KLAYTN': 8217,
  'AURORA': 1313161554,
  'ELROND': 999999,
  'TON': 999998,
  'BTTC': 199,
  'TRON': 99999999,
  'OKX': 66,
  'MOONBEAM': 1284,
  'CRONOS': 25,
  'ZKSYNC': 324,
  'HARMONY': 1666600000,
  'KAVA': 2222,
  'CANTO': 7700,
  'PULSECHAIN': 369,
  'BASE': 8453,
  'ARTHERA': 10242,
  'ARTHERA_TESTNET': 10243,
  'MANTA': 169,
  'METIS': 1088,
  'CONFLUX': 1030,
  'LINEA': 59144,
  'SOLANA': 1399811149,
}

const chainIds = (Object.keys(chainMapping) as ChainSymbol[]).map((key) => chainMapping[key])

export { chainMapping, chainIds };
